import { DECORATION_BY_TERM_TYPE, TERM_TYPES } from './termTypes';
import { Badge } from '@/ui/design-system/components/ui/badge';
import FeedbackFlagWrapper from '../FeedbackFlagWrapper';
import { formatVolume } from 'utils/helpers';

export function TermPhrase({
    termType = TERM_TYPES.KEYWORD,
    className = '',
    children,
    ...props
}) {
    const decoration =
        DECORATION_BY_TERM_TYPE[termType] ||
        DECORATION_BY_TERM_TYPE[TERM_TYPES.KEYWORD];
    return (
        <span
            className={`font-medium normal-case leading-none text-foreground ${className}`}
            {...props}
        >
            <span className="text-muted-foreground">{decoration.before}</span>
            {children}
            {decoration.after ? (
                <span className="text-muted-foreground">
                    {decoration.after}
                </span>
            ) : null}
        </span>
    );
}

export function TermFlagBadge({
    children,
    termType = TERM_TYPES.KEYWORD,
    $isTranslation,
    ...props
}) {
    const capitalizeFirstLetter =
        termType === TERM_TYPES.HASHTAG
            ? ''
            : '[&>span:first-child]:first-letter:uppercase';
    return (
        <Badge
            variant="secondary"
            className={`min-w-0 max-w-full transition-colors [&:has(button:hover)]:bg-primary [&:has(button:hover)]:text-primary-foreground [&:has(button:hover)_span]:text-primary-foreground [&:has(button:hover)_svg]:text-primary-foreground ${
                $isTranslation ? 'bg-accent italic' : ''
            }`}
        >
            <FeedbackFlagWrapper
                className={`inline-flex min-w-0 items-center gap-1 whitespace-nowrap [&>span:first-child]:min-w-0 [&>span:first-child]:truncate [&>span:last-child]:shrink-0 ${capitalizeFirstLetter}`}
                {...props}
            >
                {children}
            </FeedbackFlagWrapper>
        </Badge>
    );
}

export function TermRow({ keywordSlot, volume, ...props }) {
    return (
        <li className="flex items-end py-3" {...props}>
            {keywordSlot}
            <div className="mx-[1ch] flex-1 border-b border-dashed border-border" />
            <Badge variant="secondary" className="shrink-0 uppercase">
                {formatVolume(volume)}
            </Badge>
        </li>
    );
}

export function TermListWrapper(props) {
    return (
        <ul
            className="m-0 grid list-none grid-cols-[repeat(auto-fit,minmax(18rem,1fr))] gap-x-8 p-0"
            {...props}
        />
    );
}
